import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef } from 'react';
import cn from 'classnames';
import { Typography } from '../Typography';
import classes from './Chip.module.scss';
export const Chip = (param)=>{
    let { label, icon, selected = false, onClick, disabled = false, ariaLabel, inputMode = false, inputValue, onInputChange, onInputCommit, inputPlaceholder, inputAutoFocus = false, testId, className } = param;
    const committedRef = useRef(false);
    const handleKeyDown = useCallback((e)=>{
        if (e.key === 'Enter') {
            committedRef.current = true;
            onInputCommit === null || onInputCommit === void 0 ? void 0 : onInputCommit(e.currentTarget.value);
        }
    }, [
        onInputCommit
    ]);
    const handleBlur = useCallback((e)=>{
        if (!committedRef.current) {
            onInputCommit === null || onInputCommit === void 0 ? void 0 : onInputCommit(e.target.value);
        }
        committedRef.current = false;
    }, [
        onInputCommit
    ]);
    if (inputMode) {
        return /*#__PURE__*/ _jsx("input", {
            type: "text",
            className: cn(classes.chip, classes.input, className),
            value: inputValue !== null && inputValue !== void 0 ? inputValue : '',
            onChange: (e)=>onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(e.target.value),
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            placeholder: inputPlaceholder,
            autoFocus: inputAutoFocus,
            "data-testid": testId
        });
    }
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        className: cn(classes.chip, selected && classes.selected, className),
        "aria-pressed": selected,
        "aria-label": ariaLabel,
        disabled: disabled,
        onClick: onClick,
        "data-testid": testId,
        children: [
            icon,
            label != null && /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                weight: selected ? 'bold' : 'normal',
                className: classes.label,
                children: label
            })
        ]
    });
};
